import SearchCategories from '@olxbr/buyers-journey-repositories/searchCategories.json';
export var getFriendlyUrl = function getFriendlyUrl(keyword, category) {
  var _window, _window$location;

  if (keyword === void 0) {
    keyword = '';
  }

  var searchCategory = SearchCategories.find(function (_ref) {
    var value = _ref.value;
    return value === String(category);
  });
  var subDomain = (((_window = window) === null || _window === void 0 ? void 0 : (_window$location = _window.location) === null || _window$location === void 0 ? void 0 : _window$location.hostname) || '').split('.')[0];
  var domain = subDomain || 'www';
  var categoryQueryString = searchCategory ? "&cg=" + searchCategory.value : '';
  keyword = encodeURIComponent(keyword);
  var url = domain === 'www' || domain === 'localhost' ? "https://www.olx.com.br/brasil?q=" + keyword + categoryQueryString : "https://" + domain + ".olx.com.br/?q=" + keyword + categoryQueryString;
  return url;
};